/**
 * Configuration centralisée des langues disponibles dans l'application
 * Les données proviennent de l'API GET /api/languages via le store Pinia
 */

import { useLanguagesStore } from '@/stores/languages'

export const LANGUAGE_CODES = {
  ENGLISH: 'en',
  ENGLISH_US: 'us',
  SPANISH: 'es',
  FRENCH: 'fr',
  NETHERLANDS: 'nl',
  GERMAN: 'ge',
  DUTCH: 'du',
  HUNGARIAN: 'hu',
  PORTUGAL: 'pt',
  SHOWROOM: 'showroom',
}

export function getLanguageLabels() {
  return useLanguagesStore().labelsByCode
}

export function getLanguageLabelsEnglish() {
  return useLanguagesStore().labelsByCodeEnglish
}

/**
 * Options pour les sélecteurs (sans option vide)
 */
export const getLanguageSelectOptions = (language = LANGUAGE_CODES.FRENCH) => {
  if (language === LANGUAGE_CODES.ENGLISH) {
    return getLanguageLabelsEnglish()
  }
  return getLanguageLabels()
}
